var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    customPopoverContainer: true,
    isDisplayed: _vm.isDisplayed,
  }},[_c('div',{staticClass:"customPopoverContent"},[_c('span',{staticClass:"customePopoverSpan"},[_vm._v(" "+_vm._s(_vm.content)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }